import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Slider from 'react-slick';
import { ProductBrowserAction } from 'modules/productBrowser/actions';
import { ProductBrowserSelector } from 'modules/productBrowser/selector';
import { FilterButton } from 'components/atoms/filtersButton';
import IntroCard from 'components/molecules/introductionCard';
import { useViewport } from 'components/templates/viewportProvider';
//eslint-disable-next-line
import styles from "./style.scss";

import {
  ProductIntroMobile,
  ProductInProductIntroMobile,
  ProducttInProjectsIntroMobile,
} from 'Mock/productBrowserMock';

const ProductBrowserMobView = props => {
  const { height } = useViewport();
  const { productData, isParam, activeFilters, filteredProducts, type } = props;
  const isParams = isParam && Object.keys(isParam)[0];
  const data = activeFilters.length > 0 ? filteredProducts : productData;

  const [count, setCount] = useState({
    screenWidth: 0,
    ImageHeight: 0,
  });

  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);
    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
    };
  }, []);

  const checkParamValue = () => {
    switch (isParams) {
      case 'projectSlug':
        return ProductInProductIntroMobile;
      case 'productSlug':
        return ProducttInProjectsIntroMobile;
      default:
        return ProductIntroMobile;
    }
  };

  const displayIntro = !isParams ? ProductIntroMobile : checkParamValue();

  if (type=="Workations") {
    displayIntro.title = "Browse Offices by Products"; 
  }

  const updateWindowDimensions = () => {
    setCount({
      ...count,
      screenWidth: window.innerWidth,
      ImageHeight: window.innerHeight,
    });
  };

  const settings = {
    className: 'slider variable-width',
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    verticalSwiping: false,
    swipeToSlide: true,
    touchThreshold: 3000,
  };

  const onProductCardClick = (url_slug, id) => {
    const locationPath = props.location;
    if(type === "Workations") {
      RouteUtil.setRouteChange(
        props,
        `/workcations/product/${url_slug}`,
        locationPath.hash,
        locationPath.pathname,
        id,
        id
      );
    } else {
      RouteUtil.setRouteChange(
        props,
        `/homes/${url_slug}`,
        locationPath.hash,
        locationPath.pathname,
        id,
        ''
      );
    }
  };

  const displayProductInfo = details => {
    const { bathrooms, bedrooms, max_area, min_area } = details;
    return (
      <>
        {type !== "Workations" && (
          <div className="room-detail" key={details.id}>
          <Row>
            <span>
              {bedrooms} BEDROOMS / {bathrooms} BATH
            </span>
          </Row>
          {!max_area && !min_area ? (
            <></>
          ) : (
            <Row>
              <span>{renderProductArea(max_area, min_area)}</span>
            </Row>
          )}
        </div>
        )}
      </>
    );
  };

  const renderProductArea = (max_area, min_area) => {
    let display_area =
      min_area && !max_area
        ? min_area
        : max_area && !min_area
        ? max_area
        : `${min_area} - ${max_area}`;
    return <strong>{display_area} SQ.FEET</strong>;
  };

  const displayImage = (image_name, urlSlug) => {
    return (
      <div className="product-image" key={image_name}>
        <Row>
          <Col
            xs={{ span: 11 }}
            className="product-image-card-mob"
            style={{ height: count.ImageHeight * 0.65 }}
          >
            <img
              src={image_name}
              alt="Image Not Found"
              id={urlSlug}
              style={{ width: '100%', height: '100%' }}
            />
          </Col>
        </Row>
      </div>
    );
  };

  const displayProductName = (productName, productVersion) => {
    return (
      <div className="product-name" key={(productName, productVersion)}>
        <span className={'medium-counter'}>{productName}</span>
        <span className="product-version">{productVersion}</span>
      </div>
    );
  };

  const renderEachProduct = product => {
    const {
      detailCard: {
        productName,
        productVersion,
        url_slug,
        images: { image_path, mobile_image },
      },
      device: { mobile },
    } = product;
    let renderProduct = [];
    const image_name = image_path + mobile + '/' + mobile_image;
    renderProduct.push(displayProductName(productName, productVersion));
    renderProduct.push(displayImage(image_name, url_slug));
    renderProduct.push(displayProductInfo(product.detailCard));
    // renderRows.push(showImageData(cardType));
    return renderProduct;
  };

  const renderProducts = () => {
    const products = [];
    data.forEach(product => {
      products.push(
        <div
          key={product.detailCard.id}
          className="slides"
          style={{ width: count.screenWidth * 0.75 }}
          onClick={() =>
            onProductCardClick(
              product.detailCard.url_slug,
              product.detailCard.id
            )
          }
        >
          {renderEachProduct(product)}
        </div>
      );
    });

    return products;
  };

  return (
    <div className="product-view" style={{ height }}>
      <div className={'project-filter-sec'}>
        <FilterButton
          className={`project-filter-mobile ${
            activeFilters.length > 0 ? 'highlight' : ''
          }`}
          isMobile={true}
          theme={'light-theme'}
          filterType={'products'}
        />
      </div>
      <div>
        <IntroCard
          data={displayIntro}
          description_trim_length_mobile={5}
          callingFrom={'product-browser'}
        />
      </div>
      <div>
        {data.length > 0 ? (
          <Slider {...settings}>{renderProducts()}</Slider>
        ) : (
          <div className={'no-matches'}>No matches found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const { project, productsSelector } = props;
  return {
    filteredProducts: ProductBrowserSelector.getFilteredProducts(
      state,
      project ? project.id : null,
      productsSelector
    ),
    activeFilters: ProductBrowserSelector.getActiveProductFilterNames(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { clearProductFilters } = ProductBrowserAction;
  return bindActionCreators(
    {
      clearProductFilters,
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductBrowserMobView)
);
